import { Button, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import CustomTable from "../../../components/common/CustomTable";
import IconButton from "../../../components/common/IconButton";
import Subheader from "../../../components/ui/Subheader";
import { addKeyInArray, pathLink } from "../../../helpers/siteConfig";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  getAllRegionAsync,
  getCountRegionAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CommonParams, GetRegionData, TableData } from "../../../types/redux";
import { AddZero, countRow } from "../../../utils/number";
import { capitalize } from "../../../utils/string";

export default function Region() {
  const dispatch = useAppDispatch();
  const { limit, page, handlePagination } = useTable();
  const { regions, regionCount, loading } = useAppSelector(
    (state) => state.npGeo
  );
  const location = useLocation();
  const path = pathLink(location.pathname, 1);

  const columns: ColumnsType<TableData<GetRegionData>> = [
    {
      title: "No.",
      align: "center",
      width: 120,
      render: (_, __, idx) => countRow(page, limit, idx),
    },
    {
      title: "Cluster Name",
      dataIndex: "regionName",
      render: (val: string) => <div>{val ? capitalize(val) : "N/A"}</div>,
    },
    {
      title: "Action",
      align: "center",
      render: (val: GetRegionData) => (
        <Link to={`/${path}/geo-info/region/update-region/${val?._id}`}>
          <Button icon={<EditIcon />} />
        </Link>
      ),
    },
  ];

  useEffect(() => {
    const params: CommonParams = {
      limit: limit,
      skip: limit * (page - 1),
    };

    dispatch(
      getAllRegionAsync({
        params,
      })
    );
  }, [dispatch, limit, page]);

  useEffect(() => {
    dispatch(getCountRegionAsync());
  }, [dispatch]);

  return (
    <AdminLayout title="Cluster List" headerTitle="Geo Informations">
      <section className="mt-7">
        <Subheader
          title="Cluster List"
          subTitle={`Total Cluster: ${AddZero(regionCount)}`}
        >
          <Space size="middle">
            <Link to={`/${path}/geo-info/region/add-region`}>
              <IconButton type="primary" nextIcon={<AddIcon />}>
                Add Cluster
              </IconButton>
            </Link>
          </Space>
        </Subheader>
      </section>

      <CustomTable<TableData<GetRegionData>>
        loading={loading}
        total={regionCount}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        dataList={addKeyInArray(regions)}
        bordered={false}
      />
    </AdminLayout>
  );
}
